import type { FaireProductEntity } from "../../entity_types/product";

export const p_9f5mpjn5nw: FaireProductEntity = {
  token: "p_9f5mpjn5nw",
  type: "product",
  name: "Thanks A Bunch Set Of 8",
  brandToken: "b_cf1d364a",
  brandName: "Hartland Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/1736f168dad64dcf4e5c70f6c07cbb7ffd469ea47719b2163541f832cba12d0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f510281b4ba2b0f66f394626c8a286aa5723878e99ef0b53347204ed22a46171.jpeg",
    "https://cdn.faire.com/fastly/c4c8cf16dcc1bf576dfe3d4bbf7f7200fdc4cabe007c48b226c196056a4fc1ae.jpeg",
  ],
  priceDollars: 10,
  description:
    "- Set of 8, 4.25 x 5.5 blank cards\n- Available in Eco-kraft box\n- 100% post-consumer fiber envelope\n- Offset printed on felted paper in New York",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:48.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
